import axios from "axios";

/**
 * Asks the server for a one-time OAuth `state` bound to the session and shop.
 * The server verifies it again when Shopify redirects back to the callback.
 *
 * @param {string} shop myshopify domain, e.g. "example.myshopify.com"
 * @return {Promise<string>} the state to send to Shopify
 */
export const fetchOAuthState = async (shop) => {
  const response = await axios.post("/api/shop/shopify/oauth/state", { shop });
  return response.data.state;
};
